const CollectionImageForm = {
  cleanup: () => {},
  maybeMountInputs(thisEl: any): null | (() => void) {
    console.log('CollectionImageForm mounted')

    const isCoverImagePresent = thisEl.dataset.isCoverImagePresent

    if (isCoverImagePresent) {
      return null
    }

    const imageInput = thisEl.elements['cover_image']
    const dropzone = thisEl.querySelector('#collection-cover-image-upload-dropzone')

    console.log('thisEl.elements', thisEl.elements)

    const widthInput = thisEl.elements['collection[cover_image][width]']
    const heightInput = thisEl.elements['collection[cover_image][height]']

    if (!imageInput) {
      throw new Error('cover_image input not found')
    }

    if (!widthInput) {
      throw new Error('collection[cover_image][width] input not found')
    }

    if (!heightInput) {
      throw new Error('collection[cover_image][height] input not found')
    }

    async function handleImageChange() {
      const file = imageInput.files[0]

      if (!file) {
        return
      }

      const img = new Image()
      img.src = URL.createObjectURL(file)
      await img.decode()
      const width = img.width
      const height = img.height

      console.log('width', width)
      console.log('height', height)

      widthInput.value = width.toString()
      heightInput.value = height.toString()

      console.log('width', width)
      console.log('height', height)

      widthInput.dispatchEvent(new CustomEvent('change', { bubbles: true }))
    }

    function handleDrop(e: DragEvent) {
      e.preventDefault()
      if (!e.dataTransfer?.files.length) return

      const file = e.dataTransfer.files[0]
      if (!file) return

      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      imageInput.files = dataTransfer.files
      handleImageChange()
    }

    imageInput.addEventListener('change', handleImageChange)
    dropzone?.addEventListener('drop', handleDrop)

    return () => {
      imageInput.removeEventListener('change', handleImageChange)
      dropzone?.removeEventListener('drop', handleDrop)
    }
  },
  mounted() {
    const cleanup = this.maybeMountInputs((this as any).el)

    if (cleanup) {
      this.cleanup = cleanup
    }
  },
  updated() {
    this.cleanup()
    const cleanup = this.maybeMountInputs((this as any).el)

    if (cleanup) {
      this.cleanup = cleanup
    }
  },
}
export { CollectionImageForm }
